import { PageSize, TableState } from "components/UI/Table/types/table.ts";
import { atomFamily } from "recoil";
import { Identifiable, NonIdentifiable, TableId } from "types/models.ts";

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = PageSize.Thirty;

export const tableAtom = <T extends Identifiable | NonIdentifiable>() => {
    return atomFamily<TableState<T>, TableId>({
        key: "tableAtom",
        default: (id: TableId) => ({
            id: id,
            editingRowId: null,
            config: {
                columnsConfig: [],
            },
            columns: [],
            originColumns: [],
            page: {
                number: DEFAULT_PAGE_NUMBER,
                size: DEFAULT_PAGE_SIZE,
            },
            filter: {
                filter: undefined,
                include: undefined,
                sort: undefined,
                fields: undefined,
            },
            showOptionsFilter: false,
            showColumnsVisibility: false,
            initialized: false,
            timeFilterEnabled: false,
        }),
    });
};
